import React from "react";
import MobileRecording from "./mobileRecording";
import MobileRecordingHeader from "./mobileRecordingHeader";
import MobileContinueButton from "../button/mobileContinueButton";
import MobileCancelButton from "../button/mobileCancelButton";
import ReactTable from "react-table";
import "react-table/react-table.css";
import withFixedColumns from "react-table-hoc-fixed-columns";
import "react-table-hoc-fixed-columns/lib/styles.css";

class MobileRecordingKeyboard extends MobileRecording {
    constructor(props) {
        super();

        // in der Konsole vom Browser (Chrome):
        // monitorEvents(document.body)
        // unmonitorEvents(document.body)

        // Barcodescanner am Handheld konfigurieren
        // Modell Caribe:
        // - Settings
        //   - Output Mode
        //      -> Keyboard Mode
        //   - Additionall content
        //     -> Enter Key

        // Debuggen von anderen Devices
        // 1) Android: -> Developermodus
        // 2) Handy mit Desktop via USB-Kabel verbinden
        // 3) Desktop: chrome://inspect

        // NFC
        // Tools von TEC-IT (senden NFC-Daten in den Tastaturpuffer)
        // oder
        // https://www.npmjs.com/package/react-native-rfid-nfc-scanner
    }

    state = {currentKey: "", handleKeyPress: this.handleKeyPress};

    componentDidMount = () => {
        window.addEventListener("keydown", this.handleKeyPress);
    };

    componentWillUnmount() {
        window.removeEventListener("keydown", this.handleKeyPress);
    }

    handleKeyPress = e => {
        // this.setState({ currentKey: e.keyCode });
        // this.setState({ currentKey: e.key });
        // if (e.keyCode === 27) {
        //   console.log("You just pressed Escape!");
        // }

        const {currentRecordingFlowChart, recordData} = this.props;
        if (e.key.length === 1) {
            this.onChange(e.key);
        } else if (e.key.toUpperCase() === "ESCAPE") {
            this.onChange(e.key);
        } else if (e.key.toUpperCase() === "BACKSPACE") {
            this.onChange(e.key);
        } else if (e.key.toUpperCase() === "ENTER") {
            if (!this.isContinueButtonDisabled(currentRecordingFlowChart, recordData))
                this.onFieldContinue();
        } else {
            // case "ALTGRAPH":
            // case "ARROWDOWN":
            // case "ARROWUP":
            // case "ARROWLEFT":
            // case "ARROWRIGHT":
            // case "CAPSLOCK":
            // case "ESCAPE":
            // case "HOME":
            // case "INSERT":
            // case "NUMLOCK":
            // case "PAGEUP":
            // case "PAGEDOWN":
            // case "SHIFT":
            // case "UNIDENTIFIED":
            // case "TAB":
        }
    };

    render = () => {
        const {
            currentFlowChart,
            currentRecordingFlowChart,
            recordData
        } = this.props;

        let data = [];
        let columns = [];

        const ReactTableFixedColumns = withFixedColumns(ReactTable);

        const continueButtonDisabled = this.isContinueButtonDisabled(
            currentRecordingFlowChart,
            recordData
        );
        const selectionDisabled = this.isSelectionDisabled(
            currentRecordingFlowChart,
            recordData
        );

        columns = [
            {
                Header: (
                    <MobileRecordingHeader
                        title={currentFlowChart.title.text}
                        subTitle={
                            currentRecordingFlowChart.title.text +
                            ": " +
                            recordData.fields[
                                `${currentRecordingFlowChart.tableField}Display`
                                ]
                        }
                    />
                ),
                Cell: ({original}) => (
                    <button
                        className="btn btn-secondary btn-lg btn-block"
                        value={original.text}
                        onClick={() => {
                            this.onChange(original.text);
                        }}
                        disabled={selectionDisabled && !original.textAlwaysEnabled}
                    >
                        {original.text}
                    </button>
                ),
                Footer: () => (
                    <React.Fragment>
                        <div
                            className="btn-toolbar justify-content-between"
                            role="toolbar"
                            aria-label="Toolbar with button groups"
                        >
                            <MobileContinueButton
                                onClick={() => {
                                    this.onFieldContinue();
                                }}
                                disabled={continueButtonDisabled}
                                title={{text: "Weiter"}}
                            />
                            <MobileCancelButton
                                onClick={() => {
                                    this.onFieldCancel();
                                }}
                                title={{text: "Abbrechen"}}
                            />
                        </div>
                    </React.Fragment>
                )
            }
        ];
        data.push({id: "backspace", text: "backspace", textAlwaysEnabled: true});
        data.push({id: "clear", text: "clear", textAlwaysEnabled: true});

        return (
            <React.Fragment>
                <ReactTableFixedColumns
                    columns={columns}
                    data={data}
                    defaultPageSize={data.length}
                    showPagination={false}
                    //style={{ height: window.innerHeight }}
                />
            </React.Fragment>
        );
    }
}

export default MobileRecordingKeyboard;
